import { render } from "./ContractBox.vue?vue&type=template&id=56d0001e"
import script from "./ContractBox.vue?vue&type=script&lang=ts"
export * from "./ContractBox.vue?vue&type=script&lang=ts"
script.render = render

export default script